module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("When we were little, we used to often escape and wonder within imaginary worlds. Worlds where we felt safe, where we felt powerful and free, invincible, and even had superpowers. With the passing of time all those worlds slowly faded away and although we could travel there, they did not bring the same comfort as before, we started separating what is imaginary and what is real. This is where this book comes in. Such a cliché right, dedicated to everyone, or more to say to those who need it.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Dedicated to anyone who has lost that world, where they feel safe and protected. "), _c('em', [_vm._v("In a Million Years – Evolution Omnipotence,")]), _vm._v(" as fictitious as it is, will blur the borders between imagination and reality within your mind. As you read through the lines and immerse yourself in the story, try to take a moment to reflect on your place in the evolution-omnipotence era. Who would you be? Where will you be? What would you be doing?")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Out of millions of species on Earth, we are the only one that has looked past our cosmic domain. The only one that has reached other planets. Yes, our observations are far beyond our own solar system, but can you imagine what the chances of such things are? We are already so unique and so extraordinary that it makes me stand in awe. I, the author of "), _c('em', [_vm._v("In a Million Years – Evolution Omnipotence")]), _vm._v(" strongly believe that in the future we will be an interplanetary species and will reach unimaginable heights. And here come the second dedications, to the ones that believe in our civilization and have made it, make it and will make it all possible!")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Whoever you might be, you will always be free to do as you wish with your life. But there is one thing you need to understand; be a part of progress or do not ever stand against it! And I will see you in a million years…")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important",
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("∞ ∞ ∞")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0